import '../style/horizontaldivider.css'
export function HorizontalDivider() {


    return (

        <div id="divider" className="horizontal_divider"></div>
    )
}